import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ExplainerDialogService } from 'app/core/explainer-dialog.service';
import { Subscription } from 'rxjs';
import { Explainer, ExplainerContent } from './explainer-dialog-content';

@Component({
  selector: 'app-explainer-dialog',
  templateUrl: './explainer-dialog.component.html',
  styleUrls: ['./explainer-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ExplainerDialogComponent implements OnInit, OnDestroy {
  public explainer: Explainer;
  public content: ExplainerContent;
  public explainerDialogServiceSub: Subscription;
  public explainerDialogContentServiceSub: Subscription;
  private subscriptionArray: Subscription[] = [];
  public positionArrow = { top: false, right: false, left: false };

  constructor(public explainerDialogService: ExplainerDialogService) {}

  ngOnInit(): void {
    this.explainerDialogServiceSub = this.explainerDialogService.explainerBS.subscribe((dialog: Explainer) => {
      if (dialog) {
        this.explainer = dialog;
      }
    });

    this.explainerDialogContentServiceSub = this.explainerDialogService.explainerContentBS.subscribe(
      (dialogContent: ExplainerContent) => {
        if (dialogContent) {
          setTimeout(() => {
            this.content = dialogContent;
            this.calcPosition();
          }, 50);
        }
      },
    );
  }

  public closeExplainer(): void {
    this.explainerDialogService.closeExplainer();
  }

  private calcPosition(): void {
    this.positionArrow = { top: false, right: false, left: false };
    setTimeout(() => {
      const elem = document.getElementsByClassName('container-explainer')[0];
      if (!elem) return;
      const heightElem = elem.clientHeight;
      const widthElem = elem.clientWidth;
      const heightDoc = window.innerHeight;
      const widthDoc = window.innerWidth;
      const coordYTop = elem.getBoundingClientRect().top;
      const coordXLeft = elem.getBoundingClientRect().left;
      const coordXRight = elem.getBoundingClientRect().right;

      if (!(heightDoc - coordYTop > heightElem)) {
        this.explainer.top = coordYTop + window.pageYOffset - heightElem - 60;
        this.explainer.left = this.explainer.left - 1;
        this.positionArrow.top = true;
      }
      if (!(widthDoc - coordXLeft > widthElem)) {
        this.explainer.left = coordXLeft + 15;
        this.positionArrow.top = !this.positionArrow.top;
        this.positionArrow.right = true;
      }
      if (coordXLeft > 0 && widthDoc - coordXRight - 230 > widthElem && this.explainer.menuIsOpen) {
        // this.explainer.left = coordXRight - (widthElem/3 - 10);//It takes into side-menu
      } else if (coordXLeft < 0 && !this.explainer.menuIsOpen) {
        this.explainer.left = coordXRight - 25;
        this.positionArrow.top = !this.positionArrow.top;
        this.positionArrow.left = true;
      }
    }, 100);
  }

  get calcPositionArrow(): string {
    if (this.positionArrow.top) {
      if (this.positionArrow.right && !this.positionArrow.left) {
        return 'arrow-top-right';
      }
      if (this.positionArrow.left && !this.positionArrow.right) {
        return 'arrow-top-left';
      }
      return 'arrow-top';
    } else {
      if (this.positionArrow.right && !this.positionArrow.left) {
        return 'arrow-bottom-right';
      }
      if (this.positionArrow.left && !this.positionArrow.right) {
        return 'arrow-bottom-left';
      }
      return 'arrow-bottom';
    }
  }

  ngOnDestroy(): void {
    this.subscriptionArray.push(this.explainerDialogServiceSub, this.explainerDialogContentServiceSub);
    this.subscriptionArray.forEach((subs) => subs && subs.unsubscribe());
  }
}
